<ng-container *ngIf="tableData; else loadingTemplate">
  <div class="row d-flex justify-content-between my-3">
    <div class="col-12 col-md-6 order-2 order-md-1">
      <div class="table-search">
        <input
          #searchText
          type="search"
          class="form-control"
          placeholder="Search Topics"
          aria-label="Search"
          (input)="searchTermChanged($event)" />
      </div>
    </div>
  </div>
  <div class="table-wrapper w-100">
    <table *ngIf="tableData" class="table">
      <thead>
        <tr>
          <th scope="col" class="topics">Topic</th>
          <th scope="col" class="districtsr">Districts</th>
          <th scope="col" class="audience">Audience</th>
          <th class="np-wrap" scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="!topicsTableIsLoading; else loadingTemplate">
          <ng-container *ngIf="tableData.length > 0; else noTopics">
            <tr *ngFor="let topic of tableData">
              <td>
                <div class="fw-700">{{ topic.title }}</div>
                <!-- <div class="fs-12 color-danger fw-700">ID: {{ topic.id }}</div> -->
              </td>
              <td>
                @if(topic.districts && topic.districts.length > 0) {

                <ul>
                  @for(district of topic.districts; track district.id) {
                  <li class="fs-12">{{ district.title }}</li>
                  }
                </ul>
                }
              </td>
              <td>
                <ng-container *ngFor="let type of topic.types">
                  <span class="badge badge-item mb-2 me-1">{{
                    type.type.title
                  }}</span>
                </ng-container>
              </td>

              <td class="edit-col">
                <button
                  ngbTooltip="Preview"
                  (click)="previewTopic(topic)"
                  class="btn btn-link color-tertiary p-1">
                  <i class="bi bi-eye p-1"></i>
                </button>
              </td>
            </tr>
          </ng-container>
          <ng-template #noTopics>
            <tr>
              <td colspan="5">
                <div
                  class="d-flex flex-column align-items-center justify-content-center w-100"
                  style="min-height: 400px">
                  <h2>No Topics Found</h2>
                </div>
              </td>
            </tr>
          </ng-template>
        </ng-container>
      </tbody>
    </table>
    <section>
      <div class="d-flex justify-content-center">
        <ngb-pagination
          *ngIf="topicsListMeta && topicsListMeta.totalCount > 10"
          [(page)]="topicsListMeta.currentPage"
          [pageSize]="topicsListMeta.perPage"
          [collectionSize]="topicsListMeta.totalCount"
          [maxSize]="5"
          (pageChange)="outputChanges($event)"></ngb-pagination>
      </div>
    </section>
  </div>
</ng-container>
<ng-template #loadingTemplate>
  <div class="w-100" style="height: 700px">
    <app-loader></app-loader>
  </div>
</ng-template>

<ng-template #checked
  ><i class="bi bi-check2-circle text-info"></i
></ng-template>
<ng-template #unchecked><i class="bi bi-circle-fill"></i></ng-template>

<app-onboarding-topic-competencies-modal
  #competencyModal
  [topic]="selectedTopic" />
